export default "__VITE_ASSET__38b1867d__"